import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79dcdc80"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "logo",
  style: {"text-align":"center"}
}, "管理系统", -1))
const _hoisted_2 = { class: "company-name" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 退出登录 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_user_outlined = _resolveComponent("user-outlined")!
  const _component_a_sub_menu = _resolveComponent("a-sub-menu")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!
  const _component_menu_unfold_outlined = _resolveComponent("menu-unfold-outlined")!
  const _component_menu_fold_outlined = _resolveComponent("menu-fold-outlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createBlock(_component_a_layout, null, {
    default: _withCtx(() => [
      _createVNode(_component_a_layout_sider, {
        collapsed: _ctx.collapsed,
        "onUpdate:collapsed": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.collapsed) = $event)),
        trigger: null,
        collapsible: ""
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createVNode(_component_a_menu, {
            theme: "dark",
            mode: "inline",
            openKeys: _ctx.openKeys,
            "onUpdate:openKeys": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.openKeys) = $event)),
            selectedKeys: _ctx.selectedKeys,
            "onUpdate:selectedKeys": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedKeys) = $event))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navList, (item) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: item.menu_id
                }, [
                  (item.children.length <= 0)
                    ? (_openBlock(), _createBlock(_component_a_menu_item, {
                        key: item.menu_id,
                        onClick: ($event: any) => (_ctx.addTabs(item))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.menu_name), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : (_openBlock(), _createBlock(_component_a_sub_menu, {
                        key: item.menu_id
                      }, {
                        title: _withCtx(() => [
                          _createElementVNode("span", null, [
                            _createVNode(_component_user_outlined),
                            _createElementVNode("span", null, _toDisplayString(item.menu_name), 1)
                          ])
                        ]),
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (item1) => {
                            return (_openBlock(), _createBlock(_component_a_menu_item, {
                              key: item1.menu_id,
                              onClick: ($event: any) => (_ctx.addTabs(item1))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item1.menu_name), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1024))
                ], 64))
              }), 128))
            ]),
            _: 1
          }, 8, ["openKeys", "selectedKeys"])
        ]),
        _: 1
      }, 8, ["collapsed"]),
      _createVNode(_component_a_layout, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_layout_header, { style: {"position":"relative","background":"#fff","padding":"0"} }, {
            default: _withCtx(() => [
              (_ctx.collapsed)
                ? (_openBlock(), _createBlock(_component_menu_unfold_outlined, {
                    key: 0,
                    class: "trigger",
                    onClick: _cache[3] || (_cache[3] = () => (_ctx.collapsed = !_ctx.collapsed))
                  }))
                : (_openBlock(), _createBlock(_component_menu_fold_outlined, {
                    key: 1,
                    class: "trigger",
                    onClick: _cache[4] || (_cache[4] = () => (_ctx.collapsed = !_ctx.collapsed))
                  })),
              _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.companyName), 1),
              _createVNode(_component_a_button, {
                class: "logOut",
                type: "danger",
                onClick: _ctx.handleLogout
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_layout_content, { style: {
          margin: '24px 16px',
          padding: '24px',
          background: '#fff',
          minHeight: 'auto',
        } }, {
            default: _withCtx(() => [
              _createVNode(_component_a_tabs, {
                activeKey: _ctx.activeKeyTabs,
                "onUpdate:activeKey": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.activeKeyTabs) = $event)),
                "hide-add": "",
                type: "editable-card",
                onEdit: _ctx.onEditTabs,
                onChange: _ctx.changeTabs
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabsList, (item, i) => {
                    return (_openBlock(), _createBlock(_component_a_tab_pane, {
                      key: item.key,
                      tab: item.title,
                      closable: i > 0
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_view, {
                          name: item.url_name
                        }, null, 8, ["name"])
                      ]),
                      _: 2
                    }, 1032, ["tab", "closable"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["activeKey", "onEdit", "onChange"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}